import React from "react";
import { Box, Typography } from "@mui/material";
import Breadcrumb from "../../components/common/breadcrumb/Breadcrumb";

const breadcrumb = ["Packages For Review"];

const PackagesForReview = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <Breadcrumb pageNameList={breadcrumb} />
      <Typography variant="subtitle2">Packages For Review</Typography>
    </Box>
  );
};

export default PackagesForReview;
